/**
 * Баннер «Вышло обновление»: SPA-вкладка, открытая до деплоя, живёт со
 * старым бандлом бесконечно — пользователь репортит уже починенные баги.
 *
 * Сверяем commit, прошитый в бандл на сборке (VITE_SOURCE_COMMIT из
 * Dockerfile), с живым /healthz — по фокусу вкладки и раз в 5 минут.
 * Расхождение → плашка с кнопкой перезагрузки. В dev (commit не прошит)
 * выключено.
 */

import { useEffect, useState } from 'react';
import { Button, Group, Paper, Text } from '@mantine/core';
import { IconRefresh } from '@tabler/icons-react';

const BUILD_COMMIT = (import.meta.env.VITE_SOURCE_COMMIT as string | undefined) ?? 'dev';

export function UpdateBanner(): JSX.Element | null {
    const [stale, setStale] = useState(false);

    useEffect(() => {
        if (BUILD_COMMIT === 'dev') return;
        let cancelled = false;
        const check = async (): Promise<void> => {
            try {
                const res = await fetch('/healthz');
                const j = await res.json() as { commit?: string };
                if (!cancelled && j.commit && j.commit !== 'dev' && j.commit !== BUILD_COMMIT) {
                    setStale(true);
                }
            } catch { /* сеть моргнула — не страшно */ }
        };
        void check();
        const onFocus = (): void => void check();
        const timer = setInterval(check, 5 * 60_000);
        window.addEventListener('focus', onFocus);
        return () => {
            cancelled = true;
            clearInterval(timer);
            window.removeEventListener('focus', onFocus);
        };
    }, []);

    if (!stale) return null;

    return (
        <Paper
            shadow="md"
            radius="md"
            p="sm"
            withBorder
            style={{
                position: 'fixed', bottom: 24, left: '50%', transform: 'translateX(-50%)',
                zIndex: 500,
            }}
            data-no-print
        >
            <Group gap="sm" wrap="nowrap">
                <Text fz="sm">Вышло обновление интерфейса.</Text>
                <Button size="xs" leftSection={<IconRefresh size={14} />}
                    onClick={() => location.reload()}>
                    Обновить
                </Button>
            </Group>
        </Paper>
    );
}
